import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

const getTimeLeft = (endDate) => {
  const diff = new Date(endDate) - new Date();
  if (!Number.isFinite(diff) || diff <= 0) return null;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
};

const formatTime = ({ days, hours, minutes, seconds }) =>
  `${days}d ${hours}h ${minutes}m ${seconds}s`;

const CampaignCountdown = ({ endDate, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState(() => (endDate ? getTimeLeft(endDate) : null));
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (!endDate) {
      setTimeLeft(null);
      return undefined;
    }

    const updateTimeLeft = () => {
      const nextTimeLeft = getTimeLeft(endDate);
      setTimeLeft(nextTimeLeft);

      if (!nextTimeLeft) {
        onExpireRef.current();
      }

      return nextTimeLeft;
    };

    if (!updateTimeLeft()) {
      return undefined;
    }

    const interval = setInterval(() => {
      if (!updateTimeLeft()) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endDate]);

  if (!endDate || !timeLeft) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 0.5 }}>
      <Chip
        icon={<TimerOutlinedIcon />}
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Typography variant="body2" component="span" sx={{ fontWeight: 600 }}>
              Expires:
            </Typography>
            <Typography variant="caption" component="span" sx={{ opacity: 0.9 }}>
              {formatTime(timeLeft)}
            </Typography>
          </Box>
        }
        color="warning"
        sx={{
          height: 'auto',
          padding: '10px 14px',
          fontSize: '14px',
          fontWeight: 600,
          boxShadow: '0 4px 12px rgba(237, 108, 2, 0.25)',
          '& .MuiChip-icon': {
            fontSize: '22px',
            marginLeft: '4px',
          },
        }}
      />
    </Box>
  );
};

CampaignCountdown.propTypes = {
  endDate: PropTypes.string,
  onExpire: PropTypes.func,
};

CampaignCountdown.defaultProps = {
  onExpire: () => {},
};

export default CampaignCountdown;



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignCountdown/CampaignCountdown.jsx